import { Component, Input } from '@angular/core';

@Component({
  selector: 'njo-budget-product-allocation-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent {
  view: any[] = [750, 250];
  public renderValue: string = "";


  // options
  gradient: boolean = false;
  showLegend: boolean = true;
  showTooltip: boolean = true;

  showLabels: boolean = false;
  isDoughnut: boolean = true;
  legendPosition: string = 'right';
  customColors = [{ name: "Hours residual", value: '#B1B1B1' }]

  @Input() data: any;
  @Input() totalSpent;
  @Input() totalHoursAssigned;
}
